import SubscribeForm from "./SubscribeForm";
import SocialLinks from "./SocialLinks";

function Footer() {
  return (
    <footer>
      <div className="container footer">
        <div className="row justify-content-md-center">
          <SubscribeForm />
          <div className="col-md-12 footer-content">
            <p>&copy;{" " + new Date().getFullYear() + " The Boneheads"}</p>
            <SocialLinks type="footer" />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
